import Chaplin from 'chaplin';

const BlockOrderService = function () {
  this.orderMap = {
    blocks: [],
    order: 'default',
  };

  this.reset = () => {
    this.orderMap = {
      blocks: [],
      order: 'default',
    };
  };

  this.generateOrderMap = bv => {
    const blocks = [];
    this.getNestedModelOrderData(bv, blocks);
    const orderMap = {
      blocks,
      order: this.setCurrentOrder(blocks),
    };
    if (orderMap.order === 'end') {
      orderMap.order = 'default';
    }
    this.orderMap = orderMap;
  };

  this.getNestedModelOrderData = (bv, output) => {
    if (bv.subviews.length > 0) {
      bv.subviews.forEach(s => this.getNestedModelOrderData(s, output));
    }
    if (bv.model && output.findIndex(o => o.cid === bv.model.get('cid')) === -1) {
      output.push({
        cid: bv.model.get('cid'),
        order: bv.model.get('order') || 'default',
        state: bv.model.get('state'),
      });
    }
  };

  this.addToExistingOrderMap = bv => {
    const blocks = [];
    this.getNestedModelOrderData(bv, blocks);
    this.orderMap.blocks = [...this.orderMap.blocks, ...blocks];
  };
  this.isPageLevelBlock = block => {
    return this.orderMap.blocks.findIndex(b => b.cid === block.model.get('cid')) >= 0;
  };
  this.setCurrentOrder = blocks => {
    const filtered = blocks.filter(b => b.state !== 'completed' && b.order !== 'default');
    const sorted = filtered.sort((a, b) => {
      const aOrder = a.order === 'end' ? Number.MAX_VALUE : a.order;
      const bOrder = b.order === 'end' ? Number.MAX_VALUE : b.order;
      return aOrder - bOrder;
    });
    return sorted.length === 0 ? 'complete' : sorted[0].order;
  };

  this.getCurrentOrder = () => {
    return this.orderMap.order;
  };

  this.checkOrderMapComplete = () => {
    const { blocks } = this.orderMap;
    const filtered = blocks.filter(b => b.order !== 'end' && b.state && b.state !== 'completed');
    return filtered.length === 0;
  };

  this.hasOrderedBlocks = () => {
    const { blocks } = this.orderMap;
    for (let i = 0; i < blocks.length; i++) {
      if (blocks[i].order !== 'default') {
        return true;
      }
    }
    return false;
  };

  this.updateOrderMap = (block, pageView) => {
    const orderMap = this.orderMap;
    const blockIndex = orderMap.blocks.findIndex(b => b.cid === block.model.get('cid'));
    if (blockIndex < 0) {
      return;
    }

    orderMap.blocks[blockIndex].state = block.model.get('state');
    const prevOrder = orderMap.order;
    const newOrder = this.setCurrentOrder(orderMap.blocks);
    if (prevOrder !== newOrder) {
      const checkEndComplete = newOrder === 'end' && this.checkOrderMapComplete();
      if (checkEndComplete || newOrder !== 'end') {
        orderMap.order = newOrder;
        if (prevOrder !== 'default') {
          Chaplin.mediator.publish('block:order:completed', prevOrder);
          Chaplin.mediator.publish(`block:order-${prevOrder}:completed`);
        }
        if (newOrder !== 'complete') {
          pageView.trigger('page:state:change', pageView);
        }
      }
    }
  };
  this.addDefaultBlockOrder = blocks => {
    for (const block of blocks) {
      if (!block.type) {
        continue;
      }
      block.order = 'default';
      // Add default order for nested blocks
      Object.entries(block).forEach(([key, value]) => {
        if (Array.isArray(value)) {
          key = this.addDefaultBlockOrder(value);
        }
      });
    }
    return blocks;
  };
};
export default new BlockOrderService();
